import React from 'react'
import { useAuth } from '../../contexts/AuthContext';
import  AdminOverview  from './overview/AdminOverview';
import  EngineerOverview  from './overview/EngineerOverview';

function OverviewPage() {
    const { overviewPage } = useAuth();
  return (
    <>
      {(overviewPage == "admin" || overviewPage == "") && <AdminOverview />}
      {overviewPage == "engineer" && <EngineerOverview />}
    </>
  );
}

export default OverviewPage